
import './App.css';
import FullPageLayout from './components/page/FullPageLayout';
import Home from './pages/Home/Home';
import { Outlet, Route, BrowserRouter, Routes , Link} from 'react-router-dom';

function LayoutBase() {
  return (
    <>
      <Outlet/>
    </>
  )
}

function BlankNotFoundPage(){
  return (
    
    <FullPageLayout>
      Page not found. Navigate to <Link to="/">Home</Link>
    </FullPageLayout>
  )
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LayoutBase />}>
          <Route index element={<Home />} />
          <Route path="*" element={< BlankNotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;